// extracted by mini-css-extract-plugin
export default {"melodyVideo":"TI-z","isFullWidth":"UI-z","landingPageVideo":"VI-z","play":"WI-z","iframeVideo":"XI-z","playHidden":"YI-z","fullwidth":"ZI-z"};